<template lang="pug">
.py-10.secondary.page-home-catalogs(
  v-if="items.length",
  :class="!xs ? 'px-3' : ''"
)
  owl-carousel(:auto-width="true", :nav="false", :margin="30", :center="xs")
    v-card(
      v-for="({ img, title, to }, i) in items",
      :to="to",
      :key="i",
      width="300px",
      tile,
      flat,
      color="transparent"
    )
      img.page-home-catalogs-img.d-block(:src="img")
      .pa-2.pt-5.text-center {{ title }}
</template>

<script>
import { formatToURL } from "@/components/utils.js";
import groupBy from "lodash.groupby";

const _config = {
  mod: "catalogs",
  path: "/marcas",
};

export default {
  computed: {
    items() {
      const groups = groupBy(
        this.$rest(_config.mod).list.map((item) => {
          item.brandId = item.brand.id;
          return item;
        }),
        "brandId"
      );

      const brands = Object.entries(groups).map(([, items]) => {
        return {
          id: items[0].brand.id,
          title: items[0].brand.title,
          img: items[0].img,
        };
      });

      return brands.map(({ id, title, img }) => ({
        title,
        img: this.files + img,
        to: `${_config.path}/${formatToURL(title)}-${id}/catalogos`,
      }));
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get();
  },
};
</script>

<style>
.page-home-catalogs-img {
  aspect-ratio: 380 / 365;
  object-fit: cover;
}
.page-home-catalogs .owl-stage {
  margin: auto;
}
</style>